import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, Loader2, FileText, Plus, Car, Clock, Landmark, ChevronRight } from "lucide-react";
import Logo from "@/components/Logo";
import { getMisTramites, resetOperation } from "@/lib/api";

export default function MisTramites() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    getMisTramites()
      .then(setItems)
      .catch((e) => { setErr(e?.response?.data?.detail || "No pudimos cargar tus trámites."); setItems([]); });
  }, []);

  const nuevaSolicitud = () => {
    resetOperation();
    navigate("/registro");
  };

  return (
    <div className="min-h-screen" style={{ background: "var(--af-black)" }}>
      <div className="sticky top-0 z-40" style={{ background: "rgba(13,13,13,0.95)", backdropFilter: "blur(12px)", borderBottom: "1px solid var(--af-border-dark)" }}>
        <div className="af-container flex items-center gap-3" style={{ height: 68 }}>
          <button data-testid="mis-tramites-back" onClick={() => navigate("/")} className="text-white/80 hover:text-af-orange-core"><ArrowLeft size={22} /></button>
          <Link to="/"><Logo height={40} /></Link>
        </div>
      </div>

      <div className="af-container py-8 md:py-12 max-w-3xl" data-testid="mis-tramites-page">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <h1 className="h-impact text-white text-3xl md:text-4xl">Mis trámites</h1>
          <button onClick={nuevaSolicitud} data-testid="nueva-solicitud-btn" className="af-btn-primary flex items-center gap-2">
            <Plus size={18} /> Iniciar nueva solicitud
          </button>
        </div>

        {items === null && (
          <div className="af-card p-12 text-center"><Loader2 className="animate-spin text-af-orange-core mx-auto" size={36} /></div>
        )}

        {items !== null && items.length === 0 && (
          <div className="af-card p-10 text-center" data-testid="mis-tramites-vacio">
            <p className="text-white/80">{err || "Aún no tienes trámites. Inicia una nueva solicitud para comenzar."}</p>
            <button onClick={nuevaSolicitud} className="af-btn-primary mt-6">Iniciar nueva solicitud</button>
          </div>
        )}

        {items !== null && items.length > 0 && (
          <div className="space-y-3">
            {items.map((t) => (
              <button key={t.tramite_id} data-testid={`mis-tramites-item-${t.tramite_id}`}
                onClick={() => navigate(`/tramite/${t.tramite_id}`)}
                className="af-card p-5 w-full text-left hover:border-af-orange-core transition-colors flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="text-white/50 text-xs font-mono mb-1">Folio {t.folio}</div>
                  <div className="text-white font-semibold flex items-center gap-2"><Car size={16} className="text-af-orange-core" /> {t.vehiculo || "Vehículo por definir"}</div>
                  <div className="flex flex-wrap gap-3 text-white/60 text-sm mt-1">
                    <span className="flex items-center gap-1"><Clock size={14} className="text-af-orange-core" /> {t.modalidad}</span>
                    {t.institucion ? <span className="flex items-center gap-1"><Landmark size={14} className="text-af-orange-core" /> {t.institucion}</span> : null}
                    {t.etapa_nombre ? <span className="text-white/45">· {t.etapa_nombre}</span> : null}
                  </div>
                </div>
                <ChevronRight className="text-white/40 shrink-0" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
